/**
 * User roles enum - mirrors X4bUserRoleEnum from backend
 */
export enum X4bUserRoleEnum {
	Admin = 1,
	Manager = 2,
	User = 3,
}

